import { bootstrap } from 'vue-gtag'

export const CONSENT_VERSION = 1
export const COOKIE_KEY = 'SELLSUKI_COOKIES_CONSENT'

export const NECESSARY_COOKIE = 'necessary'
export const PERFORMANCE_COOKIE = 'performance'
export const ADVERTISING_COOKIE = 'advertising'

export const hasAcceptedCookie = (cookies) => cookies.isKey(COOKIE_KEY)

export const getAcceptedCookie = (cookies) => {
  if (hasAcceptedCookie(cookies)) {
    return cookies.get(COOKIE_KEY)
  }

  return undefined
}

export const setAcceptedCookie = ({ user, cookies, purposes = {} }) => {
  cookies.set(COOKIE_KEY, {
    consentVersion: CONSENT_VERSION,
    userId: user._id,
    purposes,
    lastUpdated: new Date().getTime()
  }, Infinity)
}

export const startGoogleAnalaytics = (gtag) => {
  bootstrap().then(() => {
    gtag.optIn()
  })
}

export const stopGoogleAnalaytics = (gtag) => {
  gtag.optOut()
}

export const startAllCookies = ({ gtag }) => {
  startGoogleAnalaytics(gtag)
}
